export default {
  // 数组去重复
  unique(map) {
    var obj = {}
    return map.filter((item, index, map) => {
      return obj.hasOwnProperty(typeof item + JSON.stringify(item)) ? false : (obj[typeof item + JSON.stringify(item)] = true)
    })
  },
  formatterDate(data, fmt) {
    if (!data) {
      return ''
    }
    data = new Date(data)
    let o = {
      'M+': data.getMonth() + 1, // 月份
      'd+': data.getDate(), // 日
      'h+': data.getHours() % 12 === 0 ? 12 : data.getHours() % 12, // 小时
      'H+': data.getHours(), // 小时
      'm+': data.getMinutes(), // 分
      's+': data.getSeconds(), // 秒
      'q+': Math.floor((data.getMonth() + 3) / 3), // 季度
      'S': data.getMilliseconds() // 毫秒
    }
    let week = {
      '0': '/u65e5',
      '1': '/u4e00',
      '2': '/u4e8c',
      '3': '/u4e09',
      '4': '/u56db',
      '5': '/u4e94',
      '6': '/u516d'
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (data.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[data.getDay() + ''])
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  cancelFlag(index) {
    const statusMap = {
      0: '有效',
      1: '作废',
    }
    return statusMap[index]
  },
  getInputValue(el) {
    let inputVal = el.target.value || ''
    return this.comdify(delcommafy(inputVal))
  },

  getDelcommafyValue(val) {
    return this.comdify(delcommafy(val))
  },

  delcommafy(num) {
    var num = num.replace(/,/gi, '')
    return num
  },
  isEmpty(obj) {
    if (typeof obj !== null || obj == '') {
      return true;
    } else {
      return false;
    }
  },
  comdify(n) {
    if (!n) return n;
    let str = n.split('.');
    let re = /\d{1,3}(?=(\d{3})+$)/g;
    let n1 = str[0].replace(re, "$&,");
    return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
  },
  upNumbers(val) {
    var cnNums = new Array(
      "零",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
      "十"
    );
    var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
    var chineseStr = "";
    if (val == "" || val == null || val == undefined) {
      return "";
    }
    val = Math.round(val * 100).toString();
    let integerNum = val.substr(0, val.length - 2);
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0;
      var IntLen = integerNum.length;
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1);
        var p = IntLen - i - 1;
        var q = p / 4;
        var m = p % 4;
        if (n == "0") {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0];
          }
          //归零
          zeroCount = 0;
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
      }
    }
    return chineseStr
  },
  smallToBig(money) {
    //  将数字金额转换为大写金额
    var cnNums = new Array(
      "零",
      "壹",
      "贰",
      "叁",
      "肆",
      "伍",
      "陆",
      "柒",
      "捌",
      "玖"
    ); //汉字的数字
    var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
    var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
    var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
    var cnInteger = "整"; //整数金额时后面跟的字符
    var cnIntLast = "元"; //整数完以后的单位
    //最大处理的数字
    var maxNum = 999999999999999.9999;
    var integerNum; //金额整数部分
    var decimalNum; //金额小数部分
    //输出的中文金额字符串
    var chineseStr = "";
    var parts; //分离金额后用的数组，预定义
    if (money == "" || money == null || money == undefined) {
      return "";
    }

    money = money.toString().replace(/,/gi, '')
    money = parseFloat(money);
    if (money >= maxNum) {
      //超出最大处理数字
      return "超出最大处理数字";
    }
    if (money == 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger;
      return chineseStr;
    }
    //四舍五入保留两位小数,转换为字符串
    money = Math.round(money * 100).toString();
    integerNum = money.substr(0, money.length - 2);
    decimalNum = money.substr(money.length - 2);
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0;
      var IntLen = integerNum.length;
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1);
        var p = IntLen - i - 1;
        var q = p / 4;
        var m = p % 4;
        if (n == "0") {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0];
          }
          //归零
          zeroCount = 0;
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m == 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q];
        }
      }
      chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum != "") {
      var decLen = decimalNum.length;
      for (var i = 0; i < decLen; i++) {
        var n = decimalNum.substr(i, 1);
        if (n != "0") {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i];
        }
      }
    }
    if (chineseStr == "") {
      chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == "" || /^0*$/.test(decimalNum)) {
      chineseStr += cnInteger;
    }
    return chineseStr;
  },
  ConverToDate(data) {
    let date = new Date(data)
    var chinese = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var y = date.getFullYear().toString();
    var m = date.getMonth() + 1;
    m = m.toString()
    var d = date.getDate().toString();
    var result = "";
    for (let i = 0; i < String(y).length; i++) {
      let z = y[i]
      result += chinese[z]
    }
    result += '年'
    if (m.length === 2) {
      if (+m[0] === 1) {
        if (+m[1] === 0) {
          result += ("十月");
        } else {
          result += ("十" + chinese[m.charAt(1)] + "月");
        }
      }
    } else {
      result += (chinese[m.charAt(0)] + "月");
    }
    if (d.length == 2 && +d.charAt(1) !== 0) {
      result += (chinese[d.charAt(0)] + "十" + chinese[d.charAt(1)] + "日");
    } else if (d.length == 2 && +d.charAt(1) === 0) {
      result += (chinese[d.charAt(0)] + "十" + "日");
    } else {
      result += (chinese[d.charAt(0)] + "日");
    }
    return result;
  }
}
// const comdify = function (n) {
//   if(!n) return n;
//   let str = n.split('.');
//   let re = /\d{1,3}(?=(\d{3})+$)/g;
//   let n1 = str[0].replace(re, "$&,");
//   return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
// }
const delcommafy = function (num) {
  if (!num) return num;
  num = num.toString();
  num = num.replace(/,/gi, '');
  return num;
}

const MoneyTest = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/
